import { EmptyState } from '@/components/ui/empty-state';
import type { LeaderboardCopy } from '../leaderboard-copy';

/** No one ranked for this language and period. */
export function LeaderboardEmpty({ copy }: { copy: LeaderboardCopy }) {
  return (
    <div className="rounded-lg border border-border/60 bg-surface">
      <EmptyState icon="users" title={copy.emptyTitle} description={copy.emptyHint} />
    </div>
  );
}
